import React, { useState, useRef } from 'react';
import { RollingModal } from 'pages/StoreImage/style';
import { CloseButton } from 'components/Button/Button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import styled from 'styled-components';
import Guide_01 from 'images/storeImage/storeImg_guide_01.png';
import Guide_02 from 'images/storeImage/storeImg_guide_02.png';
import Guide_03 from 'images/storeImage/storeImg_guide_03.png';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface RollingPopupProps {
  maskClosable?: boolean;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  canRegisterThumbnailImage?: boolean;
  canRegisterSignatureImage?: boolean;
  canRegisterMenuBoardImage?: boolean;
}

interface TStyleSwiper {
  slideidx: number;
}

const StyleSwiper = styled(Swiper)<TStyleSwiper>`
  .swiper-button-prev,
  .swiper-button-next {
    color: #afb3b8;
  }
  .swiper-button-prev:after {
    visibility: ${({ slideidx }) => (slideidx === 0 ? 'hidden' : 'visible')};
    padding-left: 40px;
    font-size: 30px;
  }
  .swiper-button-next:after {
    visibility: ${({ slideidx }) => (slideidx === 2 ? 'hidden' : 'visible')};
    padding-right: 40px;
    font-size: 30px;
  }
  .swiper-pagination-bullet-active {
    background: #606366;
  }
`;

const ViewGuideRollingPopup = ({
  maskClosable,
  open,
  onOk,
  onCancel,
  canRegisterThumbnailImage,
  canRegisterSignatureImage,
  canRegisterMenuBoardImage
}: RollingPopupProps) => {
  const swiper = useRef(null);
  const [slideIdx, setSlideIdx] = useState<number>(0);
  const handleSlideChange = (swiperInfo) => {
    setSlideIdx(swiperInfo.activeIndex);
  };

  const handleCloseModal = () => {
    setTimeout(() => {
      swiper?.current.swiper.slideTo(0);
    }, 500);
    onCancel();
  };

  return (
    <RollingModal
      maskClosable={maskClosable}
      open={open}
      onOk={onOk}
      onCancel={handleCloseModal}
      footer={[
        <CloseButton onClick={handleCloseModal} key="footer">
          닫기
        </CloseButton>
      ]}
    >
      <StyleSwiper
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        onSlideChange={(swiperChange) => handleSlideChange(swiperChange)}
        slideidx={slideIdx}
        ref={swiper}
      >
        {canRegisterThumbnailImage ? (
          <SwiperSlide>
            <img src={Guide_01} alt="thumbnail-guide" />
          </SwiperSlide>
        ) : null}
        {canRegisterSignatureImage ? (
          <SwiperSlide>
            <img src={Guide_02} alt="signature-guide" />
          </SwiperSlide>
        ) : null}
        {canRegisterMenuBoardImage ? (
          <SwiperSlide>
            <img src={Guide_03} alt="menu-guide" />
          </SwiperSlide>
        ) : null}
      </StyleSwiper>
    </RollingModal>
  );
};

export default ViewGuideRollingPopup;
